import React, { Component, createRef } from 'react';
import { Button, DatePicker, message, Typography, Table, Tooltip, Space, Upload } from 'antd';
import { RightOutlined, DeleteOutlined, DownloadOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import RenderPopover from '../../../components/RenderPopover';
import CpProductInfo from '../../../components/CpProductInfo';
import CpLoading from '../../../components/CpLoading';
import CpSteps from '../../../components/CpSteps';
import RenderItem from '../../transferOrder/components/renderitem';
import RenderNumberPopover from '../component/RenderNumberPopover';
import CancelErp from '../component/cancelErp';
import Operation from '../component/operation';
import ReceiveModal from '../component/receiveModal';
import QualityShare from '../component/quality/share';
import QualityTime from '../component/quality/time';
import UnitPrice from '../component/unitprice';
import Logistics from '../component/logistics';
import CancelOrderModal from '../component/CancelOrder';
import CustomerQuality from '../component/customer';
import { handling_opinion } from '../default';
import { statusIndexToText, statusToButtons } from '../statusConfig';
import { getAddressList } from '../../apis/address';
import { createQuality, qualityCreateAttachment, qualityDeleteAttachment, orderPurchaseErpReverse } from '../api';
import send from '../../../util/request';
import { currency } from '../../quotationProduct/formatNumber';
import { accAdd } from '../../../util/math';
import { dateFormat, amountToString, formatAddressList, downLoad, uploadBase } from '../../../util/tool';
import moment from 'moment';
import '../style.less';

const orderSteps = ['提交订单', '待发货', '待收货', '已完成'];
const confirmedSteps = ['提交订单', '待确认', '待发货', '待收货', '已完成'];
const cancelOrderSteps = ['提交订单', '待发货', '已取消'];
const TransportationType = ['无', '陆运', '海运', '空运', '陆铁联运'];
const handling_opinion_type_config = ['', '龙头处理', '运到SVC大仓', '其他', '正常进行下阶段'];
const orderStepStatus = {
  "提交订单": 1,
  "待发货": 0,
  "待收货": 0,
  "已完成": 0,
  "已取消": 0
}; // '订单状态：10-已创建；20-待发货；30-已发货|待收货；40-已完成；50-已取消'

function disabledDate(current) {
  return current && current < moment().subtract(1, "days"); //当天之前的不可选，不包括当天
}


class OrderDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      steps: [],
      stepCurrent: 1,
      orderInfo: {
        saleList: []
      },
      newArriveTime: '',
      loading: true,
      addressList: [],//地址列表
      address_id: undefined,
      fileList: [],
      modalVisible: false,
      receiveModalVisible: false,
      logVisible: false,
      cancelOrderInfo: undefined,
      cancelErpInfo: undefined
    };
    this.columns = [
      { key: 'product', name: '商品', align: 'left', colSpan: 2 },
      { key: 'unit_amount', name: '单价(元)', align: 'center' },
      { key: 'tax_rate', name: '税率', align: 'center' },
      { key: 'tax_inclusive_price', name: '商品价格(含税)', align: 'center' },
      { key: 'number', name: '数量', align: 'center' },
      { key: 'subtotal', name: '金额', align: 'center' },
      // { key: 'total', name: '总计', align: 'center' },
    ];
    this.port_quality_report_columns = [
      {
        title: '质检单号',
        dataIndex: 'quality_no',
        key: 'quality_no',
        width: 200
      },
      {
        title: '柜号',
        dataIndex: 'container_no',
        key: 'container_no',
        width: 100,
        render: (text, record) => {
          const { base = {} } = record;
          const { container_no = '' } = base;
          return container_no;
        }
      },
      {
        title: '提交时间',
        dataIndex: 'commit_time',
        key: 'commit_time',
        width: 200,
      },
      {
        title: '卖方处理状态',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        render: (text, record) => {
          return +text === 2 ? '未处理' : (+text === 3 ? '已处理' : '-');
        }
      },
      {
        title: '卖方处理意见',
        dataIndex: 'handling_opinion_desc',
        key: 'handling_opinion_desc',
        width: 200,
        render: (text, record) => {
          const { handling_opinion_desc, handling_opinion_type } = record;
          return <>
            <div>{handling_opinion_type_config[handling_opinion_type]}</div>
            <Tooltip title={handling_opinion_desc}>
              <div className='self-ellipsis'>{handling_opinion_desc}</div>
            </Tooltip>
          </>;
        }
      },
      {
        title: '操作',
        dataIndex: 'operate',
        key: 'operate',
        width: 100,
        render: (text, record) => {
          return <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography.Link onClick={() => this.goPortQualityReport(record)}>查看</Typography.Link>
            <Typography.Link onClick={() => this.goPortQualityPrint(record)}>导出</Typography.Link>
          </Space>;
        }
      },
    ];
    this.port_quality_report_columns_files = [
      {
        title: '提交时间',
        dataIndex: 'create_time',
        key: 'create_time',
        width: 150
      },
      {
        title: '文件',
        dataIndex: 'file',
        key: 'file',
        render: (text, record) => {
          return (<div className='order-quality-item-bottom'><div className='order-quality-item-bottom-item' key={record.id}>
            {record?.attachment?.url_name || record?.attachment?.name}
            <span className='order-quality-item-bottom-item-icon'>
              <span><DeleteOutlined onClick={() => this.delete_item(record)} /></span>
              <span style={{ marginLeft: 20 }}><DownloadOutlined onClick={() => this.download_item(record)} /></span>
            </span>
          </div></div>);
        }
      }
    ];
    this.warehouse_quality_report_columns = [
      {
        title: '质检单号',
        dataIndex: 'quality_no',
        key: 'quality_no',
        width: 200
      },
      {
        title: '柜号',
        dataIndex: 'container_no',
        key: 'container_no',
        width: 100
      },
      {
        title: '提交时间',
        dataIndex: 'update_time',
        key: 'update_time',
        width: 200,
        render: (text, record) => {
          const { status } = record; //1-草稿 2-已提交 3-已处理
          return <>{+status === 1 ? '-' : text}</>;
        }
      },
      {
        title: '卖方处理状态',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        render: (text, record) => {
          //1-草稿 2-已提交 3-已处理
          const status_opinion = {
            1: '-',
            2: '未处理',
            3: '已处理'
          };
          return status_opinion[+text];
        }
      },
      {
        title: '卖方处理意见',
        dataIndex: 'sale_comments',
        key: 'sale_comments',
        width: 200,
        render: (text, record) => {
          const { handling_opinions } = record;
          return +handling_opinions === 0 && !text ? '-' :
            <>
              <div>{handling_opinion[+handling_opinions]}</div>
              {
                text ? <Tooltip title={text}>
                  <div className='self-ellipsis'>{text}</div>
                </Tooltip> : '-'
              }
            </>;
        }
      },
      {
        title: '操作',
        dataIndex: 'operate',
        key: 'operate',
        width: 100,
        render: (text, record) => {
          const { status } = record; //1-草稿 2-已提交 3-已处理
          return <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
            {<Typography.Link onClick={() => this.goWarehouseQualityReport(record)}>{+status === 1 ? '编辑' : '查看'}</Typography.Link>}
            {<Typography.Link onClick={() => this.commitWarehouseQualityReport(record)}>{+status === 1 ? '提交' : ''}</Typography.Link>}
            {+status > 1 ? <Typography.Link onClick={() => this.goWarehouseQualityPrint(record)}>导出</Typography.Link> : null}
          </Space>;
        }
      },
    ];
    this.orderId = this.props.match.params.id;
    this.report = this.props.match.params.report;
    this.receiveModalRef = createRef();
  }

  componentDidMount() {
    this.requestOrderInfo(this.orderId, this.report);
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  requestAddressList = async () => {
    const { data: { data, code, msg } } = await getAddressList();
    if (+code === 0) {
      const { list } = data;
      const { address_id } = this.state;
      const addressList = formatAddressList(list);
      const hasCurrentAddress = addressList.filter(item => String(item.id) !== String(address_id));
      this.setState({ addressList: hasCurrentAddress });
    } else {
      message.error(msg);
    }
  }
  requestOrderInfo = (orderId, report) => {
    send({
      url: '/ipp/order-purchase/info',
      method: 'GET',
      params: { id: orderId }
    }).then(res => {
      const { data: { data = {}, code, msg = '' } } = res;
      if (+code === 0) {
        const { tax_inclusive_real_price, create_time, order_no, id, supplier_name, real_price, expected_date, order_desc, order_status,
          purchase_id, purchase_name, supplier_id, delivery_type, productInfo = [], syncInfo, erpInfo, supplierInfo, abroad_transport_type, domestic_transport_type,
          consignee_name, consignee_mobile, province_name, city_name, district_name, address, address_id, order_source: orderSource, parentInfo = {},
          port_quality_report = [], is_report, warehouse_quality_report = [], order_source = '', order_source_desc = '', qualifications = [], attachmentInfo = [], order_complete_total, settlement_mode } = data;
        const saleList = productInfo.map(item => ({ ...item, supplier_id }));
        const statusText = statusIndexToText['' + order_status], arriveTime = expected_date;
        const orderInfo = {
          ...data,
          tax_inclusive_real_price,
          createTime: create_time,
          orderNo: order_no,
          orderId: id,
          supplier: supplier_name,
          realPrice: real_price,
          orderStatus: +order_status,
          statusText,
          buttonText: statusToButtons['' + order_status],
          purchaseId: purchase_id, // 客户ID
          supplierId: supplier_id, //  商户ID
          orderDesc: order_desc,
          purchaseName: purchase_name,
          deliveryType: delivery_type,//物流方式 3tms
          arriveTime,
          totalPrice: real_price,
          userName: consignee_name,
          userPhone: consignee_mobile,
          address: province_name + city_name + district_name + address,
          address_id,
          parentInfo,
          orderSource,
          supplierInfo,
          syncInfo,
          erpInfo,
          saleList,
          abroad_transport_type,
          domestic_transport_type,
          port_quality_report,
          warehouse_quality_report,
          is_report,
          order_source,
          order_source_desc,
          qualifications,
          order_complete_total,
          settlement_mode
        };
        const orderStatus = Object.assign({}, orderStepStatus);
        const finallySteps = +order_status === 15 ? confirmedSteps : (+order_status === 50 ? cancelOrderSteps : orderSteps);
        const stepCurrent = finallySteps.findIndex(item => item === statusText);
        for (let i = 0; i <= stepCurrent; i++) {
          orderStatus[finallySteps[i]] = 2;
        }
        const steps = finallySteps.map(item => ({ name: item, status: orderStatus[item] })) || [];

        this.setState({
          steps,
          stepCurrent,
          orderInfo,
          loading: false,
          newArriveTime: arriveTime,
          address_id,
          fileList: attachmentInfo || []
        }, () => {
          this.requestAddressList();
        });
        if (report === '1') {
          const timer = setTimeout(function () {
            document.getElementById("report") && document.getElementById("report").scrollIntoView({ behavior: 'smooth' });
            clearTimeout(timer);
          }, 500);
        }
      } else {
        message.error(msg);
      }
    });
  }

  goPortQualityReport = (record) => {
    const { id } = record;
    this.props.history.push('/basic/user/order/portQualityReport/' + id);
  }
  goPortQualityPrint = (record) => {
    const { id } = record;
    this.props.history.push(`/qualityPrint/${id}?print=true`);
  }

  goWarehouseQualityReport = (record) => {
    const { status, quality_no } = record; //1-草稿 2-已提交 3-已处理
    this.props.history.push(`/basic/user/order/warehouseQualityReport/${this.orderId}/${status}/${quality_no}`);
  }
  goWarehouseQualityPrint = (record) => {
    const { status, quality_no } = record; //1-草稿 2-已提交 3-已处理
    this.props.history.push(`/warehouseQualityPrint/${this.orderId}/${status}/${quality_no}?print=true`);
  }

  commitWarehouseQualityReport = async (record) => {
    const { data: { code, msg } } = await createQuality({ ...record, status: 2 });
    if (+code === 0) {
      message.success('提交成功', () => this.requestOrderInfo(this.orderId));
    } else {
      message.error(msg);
    }
  }
  createWarehouseQualityReport = () => {
    this.props.history.push(`/basic/user/order/warehouseQualityReport/${this.orderId}/1/0`);
  }

  changeTime = () => {
    this.setState({
      showDatePicker: true
    });
  }

  dateChanged = (moment, date) => {
    let { arriveTime } = this.state.orderInfo;
    this.setState({
      showDatePicker: false
    });

    if (date === arriveTime) { return; }

    let today = dateFormat(new Date(), 'yyyy-MM-dd');
    if (new Date(date).getTime() < new Date(today).getTime()) {
      message.info('期望到货时间不能小于当前时间');
      this.setState({
        newArriveTime: arriveTime
      });
      return;
    }

    send({
      url: '/ipp/order-purchase/update',
      method: 'POST',
      data: {
        id: this.orderId,
        hope_arrive_time: date
      }
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success('期望到货时间修改成功');
        this.setState({
          newArriveTime: date
        });
      } else {
        message.error(res.data.msg);
        this.setState({
          newArriveTime: arriveTime
        });
      }
    });
  }

  setCurrentItem = () => {
    this.setState({ modalVisible: false });
  }
  getFormValues = (values) => {
    this.btnClicked({ ...this.state.cancelOrderInfo, ...values });
  }
  cancelOrderFu = () => {
    this.setState({ cancelOrderInfo: undefined });
  }
  btnClicked = (item) => {
    const { receive_info, cancel_desc, is_manual } = item;
    const { orderInfo } = this.state;
    const status = orderInfo.orderStatus === 30 ? 40 : 50;
    send({
      url: '/ipp/order-purchase/status',
      method: 'POST',
      data: {
        id: this.orderId,
        status,
        receive_info,
        cancel_desc,
        is_manual
      }
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success(orderInfo.buttonText + '成功', () => {
          this.receiveModalRef.current && this.receiveModalRef.current.setBillOpen && this.receiveModalRef.current.setBillOpen(true);
        });
        this.requestOrderInfo(this.orderId);
        this.setState({ cancelOrderInfo: undefined });
      } else {
        message.error(res.data.msg);
      }
    });
  }

  handleCancel = () => {
    this.setState({
      modalVisible: false
    });
  }

  handleOk = () => {
    const { orderInfo } = this.state;
    // let status = orderInfo.buttonText === '确认收货' ? 2 : 3;
    const status = orderInfo.orderStatus === 30 ? 40 : 50;

    this.setState({ modalVisible: false });

    send({
      url: '/ipp/order-purchase/status',
      method: 'POST',
      data: {
        id: this.orderId,
        status
      }
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success(orderInfo.buttonText + '成功');
        this.requestOrderInfo(this.orderId);
      } else {
        message.error(res.data.msg);
      }
    });
  }

  toProductDetail = (product) => {
    const { supplierId } = this.state.orderInfo;
    const { norms_id, sale_id } = product;
    if (!norms_id || !supplierId || !sale_id) {
      message.info('商品缺少spu_id或sale_id或supplier_id');
      return;
    }
    this.props.history.push('/basic/product/detail/' + sale_id + '/' + supplierId + '/' + norms_id);
  }

  renderOrderSourceInfo = (info = {}) => {
    const { orderSource, parentInfo = {} } = info;
    const { operate_name = '' } = parentInfo;
    const orderSourceInfo = [operate_name, 'ERP下单', '统采转单', '供应商分配'];
    return orderSourceInfo[orderSource - 1] || '';
  }

  renderSyncStatus = status => {
    return ['未同步', '已完成', '失败']?.[+status] || '-';
  }
  erpOrderPurchase = async sync_id => {
    const { data: { code, msg } } = await send({ url: '/ipp/order-purchase/send ', method: 'POST', data: { id: sync_id } });
    if (+code === 0) {
      message.success(msg, .5, this.requestOrderInfo(this.orderId));
    } else {
      message.error(msg);
    }
  }
  renderDetail = (info) => {
    if (!info) return;
    const parseInfo = JSON.parse((info));
    const surcharge_desc = !info ? [] : parseInfo;
    const record = { qoute: { surcharge_desc } };
    return <RenderPopover record={record} />;
  }
  renderNumberPopover = (info = {}) => <RenderNumberPopover info={[info]} />;

  downLoadFile = ({ file_name: name, file_url: url }) => downLoad({ url, name });

  calc_price = (orderInfo) => {
    const { tax_inclusive_real_price = 0, other_cost = 0 } = orderInfo;
    return `¥${currency(accAdd(tax_inclusive_real_price, other_cost))}`;
  }

  inspection_report_upload = async (file) => {
    const { size, type } = file;
    const isLt50M = size / 1024 / 1024 <= 50;
    if (!isLt50M) {
      message.error('文件过大!');
    }
    if (type !== 'application/pdf') {
      message.error('文件格式仅限pdf!');
      return false;
    }
    return isLt50M;
  };

  attachment_change = async (currentFile) => {
    const { orderInfo: { orderNo }, fileList = [] } = this.state;
    if (fileList?.length <= 10) {
      const currentItem = await uploadBase(currentFile);
      const { data: { data, code, msg }, } = await qualityCreateAttachment({ order_no: orderNo, attachment: [currentItem] });
      const { fileList = [] } = this.state;
      if (+code === 0) {
        this.setState({ fileList: [...fileList, ...data] });
      } else {
        message.error(msg);
      }
    } else {
      message.error('已超过最大上传数量');
    }
  };

  download_item = async ({ attachment = {} }) => {
    const { name, url_name, url } = attachment;
    await downLoad({ url, name: url_name || name });
  };
  delete_item = async ({ id }) => {
    const { fileList = [] } = this.state;
    const { data: { code, msg } } = await qualityDeleteAttachment({ id });
    if (+code === 0) {
      const newFileList = fileList.filter(item => item.id !== id);
      this.setState({ fileList: newFileList });
    } else {
      message.error(msg);
    }
  };

  updateWarehouseQualityTime = (time) => {
    this.setState(pre => ({ ...pre, orderInfo: { ...pre.orderInfo, warehouse_quality_time: time } }));
  };

  updateQualityQrcode = (qrcode) => {
    this.setState(pre => ({ ...pre, orderInfo: { ...pre.orderInfo, quality_qrcode: qrcode } }));
  };
  setCancelErpInfo = () => {
    this.setState({ cancelErpInfo: undefined });
  }

  orderPurchaseErpReverseOk = async (values) => {
    const { data: { code, msg }, } = await orderPurchaseErpReverse(values);
    if (+code === 0) {
      this.setCancelErpInfo();
      message.success(msg, () => this.requestOrderInfo(this.orderId));
    }
  }
  render() {
    const { steps, orderInfo = {}, showDatePicker, stepCurrent, loading, newArriveTime, addressList = [], fileList = [] } = this.state;
    const { saleList = [], supplierInfo = {}, syncInfo = {}, erpInfo = {}, domestic_transport_type, abroad_transport_type, qualifications = [], warehouse, rms = [], settlement_mode } = orderInfo;
    const format_warehouse = warehouse && JSON.parse(warehouse);
    const methodText = settlement_mode === 1 ? '按实际收货数量计算应付' : '订单原金额计算应付';
    return (
      <div className="order-detail">
        <Space className='mb-20' split={<RightOutlined />}>
          <Link to={{ pathname: '/basic/user/order' }}>我的采购单</Link>
          <span>订单号：{orderInfo.orderNo}</span>
        </Space>
        {loading ? <CpLoading size="large" className="cp-loading" /> : null}
        <div className="order-process">
          <div className="order-status">
            <div className="order-no">订单号：{orderInfo.orderNo}</div>
            {/* <div className="order-no">订单来源：{this.renderOrderSourceInfo(orderInfo)}</div> */}
            <div className="order-no">订单来源：{orderInfo.orderSource}</div>
            <div className="order-no order-transportation-type">
              <span>国内运输方式：{TransportationType[+domestic_transport_type]}</span>
              <span>国际运输方式：{TransportationType[+abroad_transport_type]}</span>
            </div>
            <div className="order-no">订单结算方式：{methodText}</div>
            <div className='order-status-operate'>
              <div className="order-status-text">{orderInfo.statusText}</div>
              {orderInfo.buttonText && orderInfo.buttonText.length && (
                <>
                  {+orderInfo.order_status === 20 ?
                    // <Popconfirm title={`确定${orderInfo.buttonText}?`} onConfirm={this.btnClicked}>
                    <Button className="order-buttons" size='small' onClick={() => this.setState({ cancelOrderInfo: orderInfo })}>{orderInfo.buttonText}</Button>
                    // </Popconfirm>
                    : <Button className="order-buttons" onClick={() => this.setState({ modalVisible: true })}>{orderInfo.buttonText}</Button>}
                </>
              )}
              {orderInfo.reconciliationInfo ? <Button type='primary' style={{ marginTop: 20 }} size='small' onClick={() => this.props.history.push(`/basic/user/bill?order_no=${orderInfo.order_no}`)}>查看对账单</Button> : null}
            </div>
            <div>{+orderInfo.order_status === 50 && orderInfo.cancel_desc ? `取消原因 : ${orderInfo.cancel_desc}` : null}</div>
          </div>
          <div className="order-steps">
            <div className='order-steps-status'>订单状态</div>
            <CpSteps current={stepCurrent} steps={steps} />
            <div style={{ marginTop: 20, display: 'flex', justifyContent: 'flex-end' }}><Button size='small' type='primary' onClick={() => this.setState({ logVisible: true })}>操作日志</Button></div>
          </div>
        </div>
        <div><Logistics orderNo={this.orderId} addressList={addressList} orderInfo={orderInfo}></Logistics></div>
        <div className="order-detail-info">
          <div className="order-detail-info-item">
            <div className='sub-title mb-20'>收货信息</div>
            <div className="item mb-20"><span>收货人：</span>{orderInfo.userName}</div>
            <div className="item mb-20"><span>手机号：</span>{orderInfo.userPhone}</div>
            <div className="item mb-20"><span>收货仓库：</span>{format_warehouse?.warehouse_name}</div>
            <div className="item mb-20"><span>收货地址：</span>{orderInfo.address}</div>
            {
              orderInfo.orderStatus !== 20 ?
                <div className="item"><span>预计到货时间：</span>{orderInfo.arriveTime}</div>
                :
                <div className="item pointer">
                  <span>预计到货时间：</span>
                  <DatePicker
                    bordered={false}
                    allowClear={false}
                    placeholder=""
                    suffixIcon={false}
                    open={showDatePicker}
                    defaultValue={moment(orderInfo.arriveTime)}
                    value={moment(newArriveTime)}
                    disabledDate={disabledDate}
                    onChange={this.dateChanged}
                  />
                  <span style={{ color: '#007AFF' }} onClick={() => { this.changeTime(); }}>修改</span>
                </div>
            }
          </div>
        </div>
        <div className="order-detail-info">
          <div className="order-detail-info-item">
            {/* <div className="item mb-20"><span>支付方式：</span>线下支付</div>
            <div className="item"><span>应付金额：</span>￥{orderInfo.totalPrice}</div> */}
            <div className='sub-title mb-20'>卖家信息</div>
            <div className="item mb-20"><span>供应商：</span>{orderInfo?.supplier}</div>
            <div className="item mb-20"><span>手机号：</span>{supplierInfo?.mobile || '-'}</div>
            <div className="item mb-20"><span>座机：</span>{supplierInfo?.telephone || '-'}</div>
            <div className="item mb-20"><span>邮箱：</span>{supplierInfo?.email || '-'}</div>
          </div>
          <div className="order-detail-info-item">
            {/* <div className="item mb-20"><span>创建时间：</span>{orderInfo.createTime}</div> */}
            <div className='sub-title mb-20'>ERP信息</div>
            <div className="item mb-20"><span>ERP系统：{erpInfo?.purchase_platform_no || '-'}</span></div>
            <div className="item mb-20">
              <span style={{ paddingRight: '20px' }}>ERP同步状态：{syncInfo?.sync_msg || '-'}</span>
              {(+syncInfo?.sync_id) ? <Typography.Link onClick={() => { this.erpOrderPurchase(syncInfo?.sync_id); }}>推送ERP</Typography.Link> : null}
              {(erpInfo?.purchase_order_no && (erpInfo?.is_reverse === 0) && (erpInfo?.purchase_platform_no === 'SAP')) ? <Typography.Link onClick={() => this.setState({ cancelErpInfo: true })}>取消ERP订单</Typography.Link> : null}
            </div>
            <div className="item mb-20"><span>ERP订单编号：{rms && rms.length > 0 ? rms.map((item) => {
              return <div key={item.out_order_no}>{item.out_order_no}--{item.req_err_message ? <span style={{ color: 'red' }}>{item.req_err_message}</span> : <span style={{ color: 'green' }}>{item.process_message}</span>}</div>;
            }) : (syncInfo?.order_no || '-')}</span></div>
          </div>
          <div className="order-detail-info-item">
            <div className='sub-title mb-20'>相关证件</div>
            <>{qualifications?.length ? <>{qualifications.map((item, index) => <div className="item item-file mb-20" key={index}><div>{item.file_name || item.fileName || item.name}</div><Typography.Link onClick={() => this.downLoadFile(item)}>下载</Typography.Link> </div>)}</> : <div className="item mb-20">暂无相关证件</div>}</>
          </div>
        </div>

        <UnitPrice productInfo={orderInfo.productInfo} order_complete_total={orderInfo?.order_complete_total} status={orderInfo.orderStatus} />
        <div className="order-product-list">
          <table className="cp-table">
            <thead>
              <tr>
                {
                  this.columns.map((item, index) => {
                    return (
                      <th key={index} colSpan={item.colSpan || 1} style={{ textAlign: item.align, textIndent: index === 0 ? '20px' : '' }}>
                        {item.name}
                      </th>
                    );
                  })
                }
              </tr>
            </thead>
            <tbody>
              {
                saleList.map((item, index) => {
                  return (
                    <tr key={index}>
                      {
                        this.columns.map((col, index) => {
                          if (col.key === 'product') {
                            return (
                              <td key={index} colSpan={2} style={{ maxWidth: '200px' }}>
                                <div className="p-info">
                                  <CpProductInfo product={item} toProductDetail={() => { this.toProductDetail(item); }} showSku />
                                </div>
                              </td>
                            );
                          } else if (col.key === 'number') {
                            return (
                              <td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>
                                <div>x{+item.sale_number}</div>
                                <div>{this.renderNumberPopover(item)}</div>
                              </td>
                              // <td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>x{+item.sale_number}</td>
                            );
                          } else if ((col.key === 'unit_amount')) {
                            return (<td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>￥{amountToString(item.sale_price)}</td>);
                          } else if (col.key === 'tax_rate') {
                            return (<td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>{item.tax_rate >= 0 ? (+item.tax_rate + '%') : '-'}</td>);
                          } else if (col.key === 'tax_inclusive_price') {
                            return (<td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>
                              <div style={{ display: 'flex', justifyContent: 'center' }}>{item.tax_inclusive_price === '-' ? '' : <>￥{amountToString(accAdd(item.sale_price, item.taxation))}</>}{this.renderDetail(item.surcharge_desc)}</div>
                            </td>);
                          } else if ((col.key === 'subtotal')) {
                            return (<td key={index} style={{ textAlign: 'center', fontWeight: '600' }}>￥{amountToString(+item.tax_inclusive_real_price)}</td>);
                          } else {
                            return null;
                          }
                        })
                      }
                      {/* {index === 0 ? (<td key={index} rowSpan={orderInfo.saleList.length} style={{ textAlign: 'center', fontWeight: '600', borderLeft: '1px solid #e9e9e9' }}>￥{amountToString(+orderInfo.tax_inclusive_real_price)}</td>) : null} */}
                    </tr>
                  );
                })
              }
              <tr style={{ textAlign: 'right' }}>
                <td colSpan={7}>
                  <div className='price-item'>
                    <span>商品总计:</span>
                    <span style={{ fontWeight: '600' }}>￥{currency(orderInfo.tax_inclusive_real_price)}</span>
                  </div>
                  <div className='price-item'>
                    <span>费用:</span>
                    <span>
                      ¥{currency(+orderInfo.other_cost)}
                      <RenderItem title='' item={{ other_cost: (orderInfo?.costInfo || []).map(item => ({ ...item, key: item.cost_name, value: item.cost_amount })) }} />
                    </span>
                  </div>
                  <div className='price-item'>
                    <span> 订单总金额:</span>
                    <span style={{ fontWeight: 'bolder', color: '#D60505' }}>{this.calc_price(orderInfo)}</span>
                  </div>
                  {
                    +orderInfo.orderStatus === 40 ? <div className='price-item'>
                      <span> 订单应付总金额:</span>
                      <span style={{ fontWeight: 'bolder', color: '#D60505' }}>{`¥${currency(orderInfo.productInfo?.reduce((p, n) => accAdd(p, n.receive_complete_total), 0))}`}</span>
                    </div> : null
                  }

                </td>
                {/* <td colSpan={2}>商品总计:￥{currency(orderInfo.tax_inclusive_real_price)}</td>
                <td colSpan={2}>
                  <span>费用: ¥{currency(+orderInfo.other_cost)}</span>
                  <RenderItem title='' item={{ other_cost: (orderInfo?.costInfo || []).map(item => ({ ...item, key: item.cost_name, value: item.cost_amount })) }} />
                </td>
                <td colSpan={3}>订单总金额:
                  <span style={{ fontWeight: 'bolder', color: '#D60505' }}>{this.calc_price(orderInfo)}</span>
                </td> */}
              </tr>
            </tbody>
          </table>
        </div>
        {
          (+orderInfo?.is_report) === 0 ? '' : <>
            <div className='order-quality-container'>
              <div className='order-quality-item'>
                <div className='order-quality-item-top'>
                  <div className='order-quality-item-top-left' id='report'>关口质检记录</div>
                </div>
                {
                  (orderInfo?.port_quality_report || [])?.length ?
                    <Table
                      className='order-quality-container-table'
                      dataSource={orderInfo?.port_quality_report || []}
                      rowKey='id' columns={this.port_quality_report_columns}
                      pagination={false}
                      style={{ marginBottom: '20px' }}
                    /> :
                    <div className='c'>暂未提交质检记录</div>
                }
              </div>
            </div>
            <div className='order-quality-container'>
              <div className='order-quality-item'>
                <div className='order-quality-item-top'>
                  <Space className='order-quality-item-top-left'>
                    <span>大仓质检反馈</span>
                    <QualityTime updateWarehouseQualityTime={this.updateWarehouseQualityTime} {...orderInfo} />
                  </Space>
                  <div>
                    <Button type='primary' onClick={this.createWarehouseQualityReport}>创建质检反馈</Button>
                    {
                      orderInfo?.warehouse_quality_time ? <Upload
                        name="file"
                        beforeUpload={this.inspection_report_upload}
                        fileList={fileList}
                        showUploadList={false}
                        accept="application/pdf"
                        customRequest={(file) => this.attachment_change(file)}
                        // onRemove={file => this.inspection_report_remove(file)}
                        // maxCount={10}
                        // disabled={fileList?.length >= 9}
                        multiple
                      ><Button type='primary' style={{ marginLeft: 20 }}>上传质检报告</Button></Upload>
                        : <Button type='primary' style={{ marginLeft: 20 }} onClick={() => message.error('请先填写质检时间!')}>上传质检报告</Button>
                    }
                  </div>
                </div>
                {(orderInfo?.warehouse_quality_report || [])?.length ?
                  <Table
                    className='order-quality-container-table'
                    dataSource={orderInfo?.warehouse_quality_report || []}
                    rowKey='id' columns={this.warehouse_quality_report_columns}
                    pagination={false}
                    style={{ marginBottom: '20px' }}
                  /> : null}
                {![...(orderInfo?.warehouse_quality_report || []), ...fileList].length ? <div className='c'>暂未提交质检反馈</div> : null}
                {fileList?.length ?
                  <>
                    <h4><strong>质检报告文件</strong></h4>
                    <Table
                      className='order-quality-container-table'
                      dataSource={fileList}
                      rowKey='id' columns={this.port_quality_report_columns_files}
                      pagination={false}
                      style={{ marginBottom: '20px' }}
                    />
                  </>
                  : null}
              </div>
            </div>
          </>
        }

        <CustomerQuality history={this.props.history} updateQualityQrcode={this.updateQualityQrcode} {...orderInfo} data={orderInfo?.customer_feedback || []} />
        {/* <Modal
          open={this.state.modalVisible}
          cancelText="取消"
          okText="确定"
          onOk={() => { this.handleOk(); }}
          onCancel={() => { this.handleCancel(); }}>
          {'是否' + this.state.modalContent + '?'}
        </Modal> */}
        <QualityShare updateQualityQrcode={this.updateQualityQrcode} {...orderInfo} />
        {this.state.modalVisible ? <ReceiveModal ref={this.receiveModalRef} setCurrentItem={this.setCurrentItem} item={this.state.orderInfo || {}} btnClicked={this.btnClicked} /> : null}
        {this.state.logVisible ? <Operation data={orderInfo.logsInfo || []} operationClose={() => this.setState({ logVisible: false })} /> : null}
        {this.state.cancelOrderInfo ? <CancelOrderModal getFormValues={this.getFormValues} cancelOrder={this.cancelOrderFu} /> : null}
        {this.state.cancelErpInfo ? <CancelErp orderPurchaseErpReverse={this.orderPurchaseErpReverseOk} erp_order_no={syncInfo?.order_no} order_no={this.orderId} post_date={syncInfo.finish_time} setCancelErpInfo={this.setCancelErpInfo} /> : null}
      </div >
    );
  }
}
export default OrderDetail;